import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateFornecedorPessoaFisicaModel,
  CreateSupplierModel,
  CreateSupplierNaturalModel,
  DeleteSupplierLegalModel,
  DeleteSupplierModel,
  DeleteSupplierNaturalModel,
  SearchSupplierModel,
  SearchSupplierNaturalModel,
} from '../../../models/supplier.model'
import { EditPaymentTermModel } from '../../../models/purchase-reservation.model'

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  private baseUrl = environment.baseUrl
  private resource = 'Fornecedor'
  private resourceDocument = 'FornecedorDocumento'
  private resourceLegal = 'FornecedorPessoaJuridica'
  private resourceNatural = 'FornecedorPessoaFisica'

  constructor(private httpClient: HttpClient) { }

  public createSupplier(
    model: CreateSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editSupplier(
    model: any,
    // model: EditSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteSupplier(
    model: DeleteSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedSupplier(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedSupplierDoc(
    id: any,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceDocument}/listpaginated/fornecedor/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listSupplier(
    ativo?: string,
    nome?: string,
    cnpj?: string,
    cidade?: string,
  ): Observable<ResponseRequestModel> {
    const params: string[] = []
    if (ativo) params.push(`ativo=${ativo}`)
    if (nome) params.push(`nome=${encodeURIComponent(nome)}`)
    if (cnpj) params.push(`cnpj=${encodeURIComponent(cnpj)}`)
    if (cidade) params.push(`cidade=${encodeURIComponent(cidade)}`)
    const query = params.length ? `?${params.join('&')}` : ''
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall${query}`,
    )
  }

  public getSupplierbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedSupplier(
    page: number,
    rows = 15,
    model: SearchSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public createFornecedorPessoaFisica(
    model: CreateFornecedorPessoaFisicaModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create-pessoa-fisica`,
      model,
    )
  }

  /*  Supplier Natural  */

  public createSupplierNatural(
    model: CreateSupplierNaturalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceNatural}/create`,
      model,
    )
  }

  public editSupplierNatural(
    model: any,
    // model: EditSupplierNaturalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceNatural}/edit`,
      model,
    )
  }

  public deleteSupplierNatural(
    model: DeleteSupplierNaturalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceNatural}/delete`,
      model,
    )
  }

  public listPagedSupplierNatural(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceNatural}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listSupplierNatural(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceNatural}/listall`,
    )
  }

  public getSupplierNaturalbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceNatural}/${id}`,
    )
  }

  public searchPagedSupplierNatural(
    page: number,
    rows = 15,
    model: SearchSupplierNaturalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceNatural}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  /*  Supplier Legal  */

  public createSupplierLegal(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/create`,
      model,
    )
  }

  /**
   * Vincula o papel de fornecedor a uma empresa que ja e cliente. A pessoa e reaproveitada:
   * endereco, contato, forma de pagamento, dados bancarios, documento fiscal e responsaveis
   * ja existem e nao sao regravados pelo back.
   */
  public createSupplierFromClient(
    model: FormData,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/create/from-cliente`,
      model,
    )
  }

  public editSupplierLegal(
    model: any,
    // model: EditSupplierLegalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/edit`,
      model,
    )
  }

  public deleteSupplierLegal(
    model: DeleteSupplierLegalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/delete`,
      model,
    )
  }

  public listPagedSupplierLegal(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listSupplierLegal(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/listall`,
    )
  }

  public getSupplierLegalbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/${id}`,
    )
  }

  public searchPagedSupplierLegal(
    page: number,
    rows = 15,
    model: any,
    // model: SearchSupplierLegalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public uploadDocSupplier(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceDocument}/upload`,
      model,
    )
  }
  public deleteDocSupplier(id: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceDocument}/delete/${id}`,
      id,
    )
  }

  public toggleSupplier(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/toggle`,
      model,
    )
  }

  public editPrazoPagamento(
    id: number,
    model: EditPaymentTermModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}/prazo-pagamento`,
      model,
    )
  }


  downloadDocSupplier(id: number): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}FornecedorDocumento/download/${id}`);

  }

  editDocSupplier(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}FornecedorDocumento/edit`, payload);
  }
}
